<template>
  <div v-if="$route.name === 'BajasCargas'">
    <page-header :breadcrumRoutes="routes_header" title="Bajas cargas">
      <template #buttons>
        <a-button type="primary" @click="showModal">Crear baja</a-button>
      </template>
    </page-header>

    <a-card class="mt-2">
      <a-row type="flex" justify="space-between" align="middle">
        <a-col>
          <a-row class="mt-2">
            <a-typography-title :level="4" class="text-gray-8 mr-5">
              Stock bajas cargas
            </a-typography-title>
            <a-radio-group :value="ticketsTypeSelection" @change="onChangeTabs">
              <a-radio-button
                style="margin: 1px; z-index: 0"
                value="individual"
              >
                Individuales
              </a-radio-button>
              <a-radio-button value="massive">Masivas</a-radio-button>
            </a-radio-group>
          </a-row>
        </a-col>

        <a-range-picker
          v-if="ticketsTypeSelection === 'massive'"
          v-model:value="dateRangeMassive"
          :value-format="dateFormat"
          :format="[dateFormat, dateFormat]"
        />
      </a-row>
      <a-row class="mt-3">
        <a-col :span="24">
          <tickets-table
            v-if="ticketsTypeSelection === 'individual'"
            type="Bajas de cargas"
            :v2Types="['Bajas de cargas']"
          />
          <massive-table v-else :dates="dateRangeMassive" type="Baja cargas" />
        </a-col>
      </a-row>
    </a-card>

    <!-- Modal -->
    <a-modal
      :wrapClassName="'modal-xs'"
      v-model:visible="modal_visible"
      title="Nueva solicitud de baja de cargas"
      centered
      :maskClosable="false"
    >
      <template #footer>
        <a-row type="flex" justify="end">
          <a-col>
            <a-space>
              <router-link
                class="justify-content-center d-flex"
                :to="{ name: 'BajaCargasIndividual' }"
              >
                <a-button key="1" type="primary">Individual</a-button>
              </router-link>
              <router-link
                class="justify-content-center d-flex"
                :to="{ name: 'BajaCargasMasiva' }"
              >
                <a-button key="2" type="primary">Masiva</a-button>
              </router-link>
            </a-space>
          </a-col>
        </a-row>
      </template>
      <a-typography-title class="text-gray-9 fw-regular" :level="3">
        ¿Que tipo de solicitud de baja de cargas deseas crear?
      </a-typography-title>
    </a-modal>
  </div>
  <router-view :key="$route.path"></router-view>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import { ref, defineAsyncComponent, onMounted } from 'vue';
import PageHeader from '@/components/page-header.vue';
const TicketsTable = defineAsyncComponent(
  () => import('@/components/tables/tickets-table-test.vue')
);
const MassiveTable = defineAsyncComponent(
  () => import('@/components/tables/massive-table-test.vue')
);
export default {
  name: 'Bajas',
  components: {
    'page-header': PageHeader,
    'tickets-table': TicketsTable,
    'massive-table': MassiveTable
  },

  setup() {
    // * Page Header
    const routes_header = [
      {
        // path: "first",
        breadcrumbName: 'Bajas cargas'
      }
    ];

    const route = useRoute();
    const routes = useRouter();

    // * Modal
    const modal_visible = ref(false);

    const showModal = () => {
      modal_visible.value = true;
    };

    // * Selector de fechas
    const dateFormat = 'YYYY-MM-DD';
    const ticketsTypeSelection = ref('');
    ticketsTypeSelection.value = route.hash === '' ? 'individual' : 'massive';

    const individualRoutes = ref({});
    const massiveRoutes = ref({});

    const onChangeTabs = (value) => {
      const tabValue = value.target.value;
      ticketsTypeSelection.value = tabValue;

      if (tabValue === 'massive') {
        individualRoutes.value = route.query;
        routes.replace({
          name: 'BajasCargas',
          query: massiveRoutes.value,
          hash: '#massive'
        });
      } else {
        massiveRoutes.value = route.query;
        routes.replace({
          name: 'BajasCargas',
          query: individualRoutes.value
        });
      }
    };

    const dateRangeMassive = ref([]);

    onMounted(() => {
      if (
        route.query.startDate != undefined &&
        route.query.endDate != undefined
      ) {
        if (route.hash == '#massive') {
          dateRangeMassive.value.push(route.query.startDate);
          dateRangeMassive.value.push(route.query.endDate);
        }
      }
    });

    return {
      routes_header,
      modal_visible,
      showModal,
      dateFormat,
      onChangeTabs,
      ticketsTypeSelection,
      dateRangeMassive
    };
  }
};
</script>
